
    import '/opt/buildhome/repo/packages/x/docs/x-markdown/components-data.en-US.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-x-markdown-components-data-demo-datachart"],
  getter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/opt/buildhome/repo/packages/x/docs/x-markdown/components-data.en-US.md?type=demo')
};